function AnnouncementSlider() {
  $('.cstm-announcement').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
     {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },{
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          infinite: true
        }
      }
    ]
  });
}

initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});

$(document).on('shopify:section:unload', function(event) {
  initslide();
});

function initslide() {
  $('.M-trustpilot-slider').slick({
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 575,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

function isElementMovedUpAndOutOfViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.bottom <= 0 &&
        rect.top < window.innerHeight
    );
}

function checkVisibility() {
    let ogPaymentElement = document.querySelector(".og-payment");
    let stickyatc = document.querySelector("#cstm-sticky-bar");
    if (isElementMovedUpAndOutOfViewport(ogPaymentElement)) {
        stickyatc.classList.add("mvisible");
    } else {
        stickyatc.classList.remove("mvisible");
    }
}  
  window.addEventListener("scroll", checkVisibility);
  window.addEventListener("resize", checkVisibility); // Listen for window resize
  checkVisibility();



  function updatePriceNimageSticky()
{
  var getData = document.querySelector('div#cstm-sticky-bar select.select__select').selectedOptions[0].dataset;
  var image = getData.image;
  var price = getData.price;
  var cprice = getData.cprice;
  
if(document.querySelector('div#cstm-sticky-bar img.sticky-bar-thumb-thumb'))
document.querySelector('div#cstm-sticky-bar img.sticky-bar-thumb-thumb').src= image;
  
if(document.querySelector('div#cstm-sticky-bar span.price-item.price-item--sale'))
document.querySelector('div#cstm-sticky-bar span.price-item.price-item--sale').innerHTML= price;
 
if(document.querySelector('div#cstm-sticky-bar s.price-item.price-item--regular'))
document.querySelector('div#cstm-sticky-bar s.price-item.price-item--regular').innerHTML= cprice;
}

  const targetTime = new Date().getTime() + 10 * 60 * 1000;
  function updateTimer() {
      const currentTime = new Date().getTime();
      const timeRemaining = targetTime - currentTime;
      if (timeRemaining <= 0) {
          document.getElementById("mtime").textContent = "00:00";
      } else {
          const minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
          const seconds = Math.floor((timeRemaining / 1000) % 60);
          document.getElementById("mtime").textContent = `${minutes}m ${seconds}s`;
      }
  }
  setInterval(updateTimer, 1000);
        document.addEventListener("DOMContentLoaded", function() {
        updateTimer();
      });
